/* Skeleton.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { Hide, media, Show } from '@atlaskit/primitives/responsive';
import { Skeleton } from '@atlassian/mpac-primitives';
import React from 'react';
import { HeaderSkeleton } from '../../HomePageCommonSkeleton';
import { SectionHeader } from './RegularSection';
const _5 = "@media (min-width:48rem){._1xlo19bv{height:10px}._15fl1sck{margin-top:var(--ds-space-0)}}";
const _4 = "._19pkhiv4{margin-top:var(--ds-space-400)}";
const _3 = "._4t3iftgi{height:8px}";
const _2 = "._1bsb1lit{width:10pc}";
const _ = "._2rkoiti9{border-radius:var(--ds-border-radius-100,4px)}";
export const ExploreMoreLinkSkeleton = forwardRef((_ref, __cmplr) => {
  let {
      as: C = Skeleton,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_2rkoiti9 _1bsb1lit _4t3iftgi _19pkhiv4 _1xlo19bv _15fl1sck", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  ExploreMoreLinkSkeleton.displayName = 'ExploreMoreLinkSkeleton';
}
export const RegularSectionSkeleton = _ref2 => {
  let {
    children
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SectionHeader, null, /*#__PURE__*/React.createElement(HeaderSkeleton, null), /*#__PURE__*/React.createElement(Show, {
    above: "sm"
  }, /*#__PURE__*/React.createElement(ExploreMoreLinkSkeleton, null))), /*#__PURE__*/React.createElement("div", null, children), /*#__PURE__*/React.createElement(Hide, {
    above: "sm"
  }, /*#__PURE__*/React.createElement(ExploreMoreLinkSkeleton, null)));
};